import { render, staticRenderFns } from "./esgList.vue?vue&type=template&id=739775fb&scoped=true"
import script from "./esgList.vue?vue&type=script&setup=true&lang=ts"
export * from "./esgList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./esgList.vue?vue&type=style&index=0&id=739775fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739775fb",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxToolbarSection: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/toolbarSection.vue').default,CompanyLogo: require('/home/runner/work/assessment-service/assessment-service/frontend/components/company/CompanyLogo.vue').default,IxScoreRemark: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/scoreRemark.vue').default,IxReferencePeriodPill: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/ReferencePeriodPill.vue').default})
